import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Translation, TranslocoLoader} from '@jsverse/transloco';

/**
 * Carica i dizionari i18n dagli asset statici.
 * - root scope `common`:   assets/i18n/{lang}.json
 * - scope per-feature:      assets/i18n/{scope}/{lang}.json  (lang === "scope/xx")
 */
@Injectable({providedIn: 'root'})
export class TranslocoHttpLoader implements TranslocoLoader {

  private http = inject(HttpClient);

  getTranslation(lang: string): Observable<Translation> {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}
